/*
 * Additional.ts
 * Description: Includes so other function declarations
 */

// Importing variables
import {APIURL, DeletedSuccessful, Warning} from '@/ts/variables';
// Importing Axios (used for HTTP requests)
import Axios from 'axios';
// Importing normalize function
import normalize from 'normalize-json-api-response';
// Importing Sweet alert 2
import Swal from 'sweetalert2';
import {deleteAddress} from '@/ts/profile/addresses/delete-address';

/**
 * Search for restaurant names, tags and towns.
 *
 * @return {Object} Promise - search results
 * @param {String} query - query text
 */
export function APILookUp(query: string) {
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'search?query=' + query,
            method: 'get',
            data: {},
        }).then((response) => {
            resolve(response);
        }).catch((error) => {
            reject(error);
        });
    });
}

/**
 * Getting rankings
 *
 * @return {Object} Promise - rankings
 */
export function getRankings() {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'rankings',
            method: 'get',
            data: {},
        }).then((response) => {
            resolve(normalize(response.data));
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Getting tags
 *
 * @return {Object} Promise - a list of tags
 */
export function getTags() {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'tags',
            method: 'get',
            data: {},
        }).then((response) => {
            const tags = [];
            for (const tag of response.data.data) {
                tags.push(
                    tag.attributes.name,
                );
            }
            resolve(tags);
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Get current user after log in
 *
 * @return {Object} Promise - user data
 */
export function getCurrentUser() {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url: APIURL + 'auth/user',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data.data.relationships);
        }).catch((error) => {
            reject(error);
        });
    });
}

/**
 * Modal confirmation function
 *
 * @return {Object} Promise - whether action was confirmed
 */
export function modalConfirm() {
    return new Promise((resolve, reject) => {
        Swal.fire({
            title: Warning,
            text: DeletedSuccessful,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Отказ',
            confirmButtonText: 'Изтриване',
        }).then((result) => {
            if (result.value) {
                resolve();
            } else {
                reject();
            }
        });
    });
}

export function submitCart() {
    return new Promise((resolve, reject) => {
        Swal.fire({
            title: 'Сигурни ли сте?',
            text: 'Поръчката ще бъде окончателно финализирана и изпратена към ресторанта!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Отказ',
            confirmButtonText: 'Финализиране',
        }).then((result) => {
            if (result.value) {
                Swal.fire(
                    'Поръчката финализирана успешно!',
                    '',
                    'success',
                );
                resolve();
            } else {
                reject();
            }
        });
    });
}

/**
 * Handling scroll animation
 *
 */
export function handleScroll() {
    const items = document.querySelectorAll('.has-animation');
    const height = window.innerHeight + window.scrollY;
    for (const index of items.keys()) {
        if (height >= (items[index] as any).offsetTop) {
            setTimeout(() => {
                items[index].classList.add('animate-in');
            }, 250);
        }
    }
}
